/**
 * Jacquard cookie schema (ADR-023 §4 + ADR-025 §7).
 *
 * All cookies use the `jq-` prefix, which is a Z1 reserved namespace.
 * New cookies can be added in minor versions per the additivity contract.
 */

export const COOKIE_KEYS = {
  theme: 'jq-theme',
  direction: 'jq-dir',
  locale: 'jq-locale',
  brandSeed: 'jq-brand-seed',
  density: 'jq-density',
} as const;

export type CookieKey = (typeof COOKIE_KEYS)[keyof typeof COOKIE_KEYS];

export type ThemeValue = 'dark' | 'light' | 'system';
export type DirectionValue = 'ltr' | 'rtl';
export type DensityValue = 'compact' | 'comfortable';

/** Read a specific Jacquard cookie value from a cookie string. */
export function readCookie(cookieString: string, key: CookieKey): string | undefined {
  const match = cookieString.match(new RegExp(`${key}=([^;]+)`));
  return match?.[1];
}
